import { render, staticRenderFns } from "./ng-registered-model.vue?vue&type=template&id=19d50c1d&scoped=true&"
import script from "./ng-registered-model.vue?vue&type=script&lang=js&"
export * from "./ng-registered-model.vue?vue&type=script&lang=js&"
import style0 from "./ng-registered-model.vue?vue&type=style&index=0&id=19d50c1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d50c1d",
  null
  
)

export default component.exports